import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useCheckOperationType() {
  const route = useRoute();

  const isSet = computed(() => {
    return route.params.issueType === 'sets';
  });

  const isStation = computed(() => {
    return route.params.issueType === 'stations';
  });

  const isHME = computed(() => {
    return route.params.issueType === 'heavy_mobile_equipment';
  });

  const isOverview = computed(() => {
    return route.params.issueType === 'overview';
  });

  const isPlant = computed(() => {
    return route.params.issueType === 'plant';
  });

  return { isSet, isStation, isHME, isOverview, isPlant };
}
